module.exports = __webpack_public_path__ + "static/media/21-years-logo.d4f21229.png";